import React, {Component} from 'react';
import T from 'i18n-react';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
// Composants
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
// Style
import '../ReportingHeader.css';
// Enum
import JOB_STATUS from "../../../enums/JobStatus";
import MaterialFormInput from "../../materialFormInput/MaterialFormInput";
import JOB_TYPE from '../../../enums/JobType';

/**
 * Composant affichant les filtres pour la page d'historique des imports
 */
class JobHistoryFilters extends Component {

    constructor(props) {
        super(props);

        //Tri par ordre alphabétique de libellés
        const jobStatusList = Object.keys(JOB_STATUS).sort((a, b) => {
            return T.translate(`jobHistory.jobStatus.${a}`) < T.translate(`jobHistory.jobStatus.${b}`) ? -1 : 1
        })
        this.allStatusList = (selectedValueList) =>  jobStatusList.map((value, index) => (
            <MenuItem className="job-status" key={index} value={value} checked={selectedValueList && selectedValueList.includes(value)} primaryText={T.translate(`jobHistory.jobStatus.${value}`)} />
        ));

        //Tri par ordre alphabétique de libellés
        const jobTypeList = Object.keys(JOB_TYPE).sort((a, b) => {
            return T.translate(`jobHistory.jobType.${a}`) < T.translate(`jobHistory.jobType.${b}`) ? -1 : 1
        })
        this.allJobTypeList = (selectedValueList) => jobTypeList.map((value, index) => (
            <MenuItem className="job-status" key={index} value={value} checked={selectedValueList && selectedValueList.includes(value)} primaryText={T.translate(`jobHistory.jobType.${value}`)} />
        ));
    }

    render() {
        return (
            <div className="filterContainer">
                <div>
                    <label>{T.translate("tableHeader.beginDate")} :</label>
                    <DatePicker
                        name="date-picker-job-history"
                        className="datePickerHeader"
                        value={this.props.startDate}
                        maxDate={this.props.endDate}
                        onChange={(event, date) => this.props.handleFilterChange('startDate', date)}
                    />
                </div>
                <div>
                    <label>{T.translate("tableHeader.endDate")} :</label>
                    <DatePicker
                        name="date-picker-job-history"
                        className="datePickerHeader"
                        value={this.props.endDate}
                        minDate={this.props.startDate}
                        onChange={(event, date) => this.props.handleFilterChange('endDate', date)}
                    />
                </div>
                <MaterialFormInput
                    hintText={T.translate('jobHistory.filename')}
                    id="filenameInput"
                    className="searchInput"
                    value ={this.props.fileName ? this.props.fileName : '' }
                    onChange={(event, value) => this.props.handleFilterChange('fileName', value, true)}
                />
                <SelectField id="filetypeInput"
                             className='profileDropdown'
                             value={this.props.jobTypeList}
                             hintText={T.translate("jobHistory.allFileType")}
                             multiple={true}
                             onChange={(event, key, value) => this.props.handleFilterChange('jobTypeList', value)}
                             dropDownMenuProps={{
                                 anchorOrigin: {
                                     vertical: "bottom",
                                     horizontal: "left"
                                 },
                             }}>
                    {this.allJobTypeList(this.props.jobTypeList)}
                </SelectField>
                <SelectField className='profileDropdown'
                             value={this.props.statusList}
                             hintText={T.translate("jobHistory.allStatus")}
                             multiple={true}
                             onChange={(event, key, value) => this.props.handleFilterChange('statusList', value)}>
                    {this.allStatusList(this.props.statusList)}
                </SelectField>

                <IconButton tooltip={T.translate('jobHistory.resetFilters')} onClick={this.props.resetFilters}>
                    <FontIcon className="material-icons"  color="inherit">close</FontIcon>
                </IconButton>
            </div>
        );
    }

    /**********************************************************
     ************************ Filtre  *************************
     **********************************************************/


    /**********************************************************
     ********************* User Action *************************
     **********************************************************/

}

export default JobHistoryFilters;



// WEBPACK FOOTER //
// ./src/components/tableComponent/jobHistory/JobHistoryFilters.js